import { stringFormattingToCurrency } from "js/formatting";
import { useTranslation } from "react-i18next";
import { v4 as uuidv4 } from "uuid";
import { useEffect, useState } from "react";
import { isOldAlicUlPolicy } from "js/utilities";
import FormInputError from "components/General/FormInputError";
export default function PaymentAmount({
  register,
  setCurrentStep,
  policy,
  setValue,
}) {
  const { t } = useTranslation();
  const [isDisabled, setIsDisabled] = useState(false);
  const [error, setError] = useState();
  useEffect(() => {
    if (policy?.modalPremiumAmountTotal && !isOldAlicUlPolicy(policy)) {
      setValue(
        "amount",
        stringFormattingToCurrency(policy?.modalPremiumAmountTotal)
      );
      setCurrentStep(3);
    } else {
      setValue("amount", Number(policy?.modalPremiumAmountTotal).toFixed(2));
    }
  }, [policy]);
  const paymentAmtId = uuidv4();

  return (
    <>
      <div className="ui-form-card-no-event">
        <label
          id={paymentAmtId + "-label"}
          htmlFor={paymentAmtId}
          className="block mb-1"
        >
          {t("UnauthMakeAPayment-paymentamount")}
        </label>
        {isOldAlicUlPolicy(policy) ? (
          <>
            <div className="relative">
              <input
                id="paymentAmtId"
                className="border border-ui-gray-medium h-9 w-full p-2 pl-8 top-1/2 rounded"
                aria-labelledby={paymentAmtId + "old-alic-label"}
                placeholder="Please enter pay amount"
                {...register("amount", {
                  required: t("UnAuthMakeAPayment-required-error"),
                })}
                onChange={(e) => {
                  if (isNaN(e.target.value)) {
                    setCurrentStep(2);
                    setError(t("UnAuthMakeAPayment-required-error"));
                    setIsDisabled(true);
                  } else {
                    if (e.target.value > 0) {
                      setValue("amount", e.target.value);
                      setIsDisabled(false);
                      setError(undefined);
                    } else {
                      setCurrentStep(2);
                      setError(t("UnAuthMakeAPayment-required-error"));
                      setIsDisabled(true);
                    }
                  }
                }}
              />
              <svg
                className="absolute text-theme-action top-1/2 mt-[-10px] ml-2"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
              >
                <use href="#ui-icon-dollar"></use>
              </svg>
            </div>
            <FormInputError id="id_amount" errorMessage={error} />
            <div
              id={paymentAmtId + "-help"}
              className="text-xxs text-theme-text-tertiary mt-1"
            >
              {t("UnAuthMakeAPayment-message")}
            </div>
            <div className="block text-right">
              <button
                id="ID_submitPayment"
                type="button"
                className="ui-btn-primary min-w-[140px]"
                aria-label="submit payment"
                disabled={isDisabled}
                onClick={() => {
                  setCurrentStep(3);
                }}
              >
                {t("UnauthMakeAPayment-paymentpolicy-continue")}
              </button>
            </div>
          </>
        ) : (
          <>
            <input
              id={paymentAmtId}
              disabled={true}
              aria-labelledby={paymentAmtId + "-label"}
              aria-describedby={`
            ${paymentAmtId + "-help"}
            ${paymentAmtId + "-error"}
          `}
              type="text"
              placeholder="Please enter pay amount"
              {...register("amount")}
            />
            <div
              id={paymentAmtId + "-help"}
              className="text-xxs text-theme-text-tertiary mt-1"
            >
              {t("UnauthMakeAPayment-use")}
            </div>
          </>
        )}
      </div>
    </>
  );
}
